<template>
  <v-dialog
    :value="value"
    persistent
    width=400>
    <v-card>
      <v-container>
        <v-row
          justify=center>
          <v-col
            cols=auto>
            お子さまの登録を抹消します。<br>
            確認のため、下の入力欄に「<i>delete</i>」と入力してください。
          </v-col>
        </v-row>
        <v-row
          >
          <v-col
            cols=12>
            <v-text-field
              v-model="confirmText"
              label="delete"
              type="text"
              v-validate="'required|confirmed:confirmTarget'"
              data-vv-name="confirmText"
              data-vv-as="確認用テキスト"
              required
              :error-messages="errors.collect('confirmText')"
              />
          </v-col>
        </v-row>
        <v-row
          v-show="false">
          <v-col>
            <v-text-field
              v-model="confirmTarget"
              data-vv-name="confirmTarget"
              ref="confirmTarget"
              ></v-text-field>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=auto>
            <v-btn
              outlined
              depressed
              rounded
              @click="$emit('close-button-click')">閉じる</v-btn>
          </v-col>
          <v-col
            cols=auto>
            <v-btn
              outlined
              depressed
              rounded
              color="grey"
              @click="main">OK</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    }
  },
  data () {
    return {
      confirmText: "",
      confirmTarget: "delete"
    }
  },
  methods: {
    main () {
      this.$validator.validateAll().then((result) => {
        if (result && this.confirmText === 'delete') {
          this.$emit('confirm-button-click')
        }
      })
    }
  }
}
</script>
